import { PropsWithChildren } from "react";
import styled from "styled-components";

import { HorizontalLine, Panel } from "capitalrx-components-2.0/lib/general";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Subtitle } from "capitalrx-components-2.0/lib/typography";

export interface ContentPanelProps extends PropsWithChildren {
  readonly title?: string | JSX.Element;
  readonly showBorder?: boolean;
}

const ThemedPanel = styled(Panel)`
  border-top: solid 4px !important;
  border-top-color: ${(props) => props.theme.primary_color} !important;
`;

export const ContentPanel = ({ title, children, showBorder = false }: ContentPanelProps) => {
  return (
    <ThemedPanel>
      <Stack spacing="medium">
        {!!title && (
          <>
            {typeof title === "string" && <Subtitle>{title}</Subtitle>}
            {typeof title !== "string" && title && <>{title}</>}
          </>
        )}
        {showBorder && <HorizontalLine />}
        <div style={{ paddingTop: "1.125rem" }}>{children}</div>
      </Stack>
    </ThemedPanel>
  );
};
